import { useGlobal } from '@/utils/useGlobal';

export const useUsCaConfig = (locale: string) => {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    const cards = [
        {
            img: '',
            power: t('secH_card5_power'),
            title: t('secH_card5_title'),
            with: t('secH_card5_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/45w-portable-solar-panel?variant=41731341353033',
                    ca: 'https://ca.ecoflow.com/products/45w-portable-solar-panel?variant=52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7264162676809',
                    ca: '8292312449178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41731341353033',
                    ca: '52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card5_desc1'), t('secH_card5_desc2'), t('secH_card5_desc3')],
        },
        {
            img: '/responsive/picture/common-products/110w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/110w-portable-solar-panel?variant=39998109941833',
                    ca: 'https://ca.ecoflow.com/products/110w-portable-solar-panel?variant=43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            img: '/responsive/picture/common-products/160w.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=41682906218569',
                    ca: 'https://ca.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003543044169',
                    ca: '8066687074458',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41682906218569',
                    ca: '52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            img: '/responsive/picture/common-products/220w_bifacial.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-220w-bifacial-portable-solar-panel?variant=41670394576969',
                    ca: 'https://ca.ecoflow.com/products/220w-bifacial-portable-solar-panel?variant=43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
    ];
    const eu_cards: any = [
        {
            img: '/responsive/picture/common-products/400w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/400w-portable-solar-panel',
                    fr: 'https://fr.ecoflow.com/products/400w-portable-solar-panel',
                    eu: 'https://eu.ecoflow.com/products/400w-portable-solar-panel',
                    uk: 'https://uk.ecoflow.com/products/400w-portable-solar-panel',
                    it: 'https://it.ecoflow.com/products/400w-portable-solar-panel',
                    es: 'https://es.ecoflow.com/products/400w-portable-solar-panel',
                    nl: 'https://nl.ecoflow.com/products/400w-portable-solar-panel',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15536875929981',
                    fr: '10084432576859',
                    eu: '10265047433559',
                    uk: '10123990729043',
                    it: '14963038814584',
                    es: '10084460560731',
                    nl: '9935698034964',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '56938043769213',
                    fr: '51300297998683',
                    eu: '51736552538455',
                    uk: '51828861469011',
                    it: '55270023627128',
                    es: '51300335288667',
                    nl: '51194372948244',
                };
                return localMap[locale] || localMap.eu;
            })(),

            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            img: '/responsive/picture/common-products/220W_portable_new.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=57942851748221',
                    fr: 'https://fr.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=52616630239579',
                    eu: 'https://eu.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=53041509859671',
                    uk: 'https://uk.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=53283554853203',
                    it: 'https://it.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=55504034234744',
                    es: 'https://es.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=52616642691419',
                    nl: 'https://nl.ecoflow.com/products/220w-lightweight-portable-solar-panel?variant=52286118920468',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15838486921597',
                    fr: '10391185260891',
                    eu: '10627802726743',
                    uk: '10493653909843',
                    it: '15013825413496',
                    es: '10391187849563',
                    nl: '10166971400468',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '57942851748221',
                    fr: '52616630239579',
                    eu: '53041509859671',
                    uk: '53283554853203',
                    it: '55504034234744',
                    es: '52616642691419',
                    nl: '52286118920468',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            img: '/responsive/picture/common-products/160W_portable_new.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=58073819644285',
                    fr: 'https://fr.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=52845277348187',
                    eu: 'https://eu.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=53358287487319',
                    uk: 'https://uk.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=53531227062611',
                    it: 'https://it.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=55535952626040',
                    es: 'https://es.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=52845394985307',
                    nl: 'https://nl.ecoflow.com/products/160w-lightweight-portable-solar-panel?variant=52380622979348',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '15868922691965',
                    fr: '10445241352539',
                    eu: '10767356068183',
                    uk: '10550400581971',
                    it: '15021956333944',
                    es: '10445280608603',
                    nl: '10187320262932',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '58073819644285',
                    fr: '52845277348187',
                    eu: '53358287487319',
                    uk: '53531227062611',
                    it: '55535952626040',
                    es: '52845394985307',
                    nl: '52380622979348',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
        {
            img: `/responsive/picture/common-products/110w.png`,
            power: t('secH_card4_power'),
            title: t('secH_card4_title'),
            with: t('secH_card4_with'),
            link_more: (() => {
                const localMap: any = {
                    de: 'https://de.ecoflow.com/products/100w-flexible-solar-panel?variant=42952014823671',
                    fr: 'https://fr.ecoflow.com/products/100w-flexible-solar-panel?variant=43245599654114',
                    eu: 'https://eu.ecoflow.com/products/100w-flexible-solar-panel?variant=42347831722148',
                    uk: 'https://uk.ecoflow.com/products/100w-flexible-solar-panel?variant=42914703409344',
                    it: 'https://it.ecoflow.com/products/100w-flexible-solar-panel?variant=43234258387185',
                    es: 'https://es.ecoflow.com/products/100w-flexible-solar-panel?variant=43361884864734',
                    nl: 'https://nl.ecoflow.com/products/100w-flexible-solar-panel?variant=51194374881556',
                };
                return localMap[locale] || localMap.eu;
            })(),
            productId: (() => {
                const localMap: any = {
                    de: '7686916931831',
                    fr: '7843492659426',
                    eu: '7346811994276',
                    uk: '7293362110656',
                    it: '7795654951153',
                    es: '7784277835998',
                    nl: '9935698985236',
                };
                return localMap[locale] || localMap.eu;
            })(),
            variantId: (() => {
                const localMap: any = {
                    de: '42952014823671',
                    fr: '43245599654114',
                    eu: '42347831722148',
                    uk: '42914703409344',
                    it: '43234258387185',
                    es: '43361884864734',
                    nl: '51194374881556',
                };
                return localMap[locale] || localMap.eu;
            })(),
            descArr: [t('secH_card4_desc1'), t('secH_card4_desc2'), t('secH_card4_desc3')],
        },
    ];

    return {
        cards,
        eu_cards,
    };
};
